export default "__VITE_PUBLIC_ASSET__e0ef17c5__"